app.service('LoginService', [
    '$q', '$timeout', '$rootScope',
    'Utils', 'API', 'constants', 'ErrorService', 'UserService', 'LocalStorage',
    'ServerTimeService', 'AssetService', 'OpenTradeService', 'ClosedTradeService', 'TransactionHistoryService',
    'PnlMarginService', 'FavoritesService', '$injector', 'WithdrawHistoryService',
    'FirebaseService', 'SocialAuthService', 'VerificationV2Service', 'CustomerEventsService',
    function ($q, $timeout, $rootScope,
              Utils, API, Const, ErrorService, UserService, LocalStorage,
              ServerTimeService, AssetService, OpenTradeService, ClosedTradeService, TransactionHistoryService,
              PnlMarginService, FavoritesService, $injector, WithdrawHistoryService,
              FirebaseService, SocialAuthService, VerificationV2Service, CustomerEventsService) {

        var self = this;

        var initChain = [
                ServerTimeService.init,
                FavoritesService.init,
                AssetService.init,
                OpenTradeService.init,
                ClosedTradeService.init,
                TransactionHistoryService.init,
                PnlMarginService.init,
                WithdrawHistoryService.init,
                VerificationV2Service.init
            ],

            clearChain = [
                Utils.wait(1000),
                ServerTimeService.clear,
                PnlMarginService.clear,
                OpenTradeService.clear,
                ClosedTradeService.clear,
                TransactionHistoryService.clear,
                FavoritesService.clear,
                AssetService.clear,
                UserService.clear,
                WithdrawHistoryService.clear
            ],

            mt4InitChain = [
                FavoritesService.init,
                AssetService.init,
                OpenTradeService.init,
                ClosedTradeService.init,
                TransactionHistoryService.init,
                WithdrawHistoryService.init,
                PnlMarginService.init
            ],

            mt4ClearChain = [
                PnlMarginService.clear,
                OpenTradeService.clear,
                ClosedTradeService.clear,
                TransactionHistoryService.clear,
                WithdrawHistoryService.clear,
                FavoritesService.clear,
                AssetService.clear
            ];

        var fingerprint = new Fingerprint({canvas: true}).get();

        function checkTokenResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'LoginService',
                    type: Const.error.type.VALIDATION,
                    code: 'tokenFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        //create user and fill its data
        function initUser(data) {
            return UserService.login(data.customer);
        }

        //login sequence via token only
        this.loginToken = function () {
            var token = Utils.getURLParameterByName('token') || LocalStorage.get('token');

            function createRequest() {
                if (Const['authType'] && Const['authType'] === 'webtrader') {
                    return API.loginTokenWebTrader({token: token, fingerprint: fingerprint});
                }
                return API.loginTokenDetailsMT4({token: token, fingerprint: fingerprint});
            }

            if (token && token.length > 0) {
                log('relogin with existing token');
                return createRequest()
                    .then(checkTokenResponse)
                    .then(function (data) {
                        saveToken({token: token});
                        return data;
                    })
                    .then(initUser)
                    .then(function () {
                        CustomerEventsService.startSessionPing(UserService.get())
                    })
                    .catch(function (error) {
                        LocalStorage.remove('token');
                        CustomerEventsService.stopSessionPing();
                        return $q.reject(error);
                    })
                //.then(self.mt4LoginSequence);
            }

            LocalStorage.remove('token');
            return $q.reject('noToken');
        };

        /* forex login flow */
        function checkLogin(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'LoginService',
                    type: Const.error.type.VALIDATION,
                    code: data.code || 'authFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }

            return data;
        }

        function saveToken(data) {
            var user = UserService.get();
            user.token = data.token;
            LocalStorage.set('token', data.token);
            return data;
        }

        this.mt4LoginSequence = function () {
            var user = UserService.get();
            var tradeableAccount = user.getTradeableAccount();

            if (tradeableAccount) {
                return API.mt4Login({source: tradeableAccount.source, loginID: tradeableAccount.login})
                    .then(checkTradeLogin)
                    .then(user.onMT4Login)
                    .then(function () {
                        user.setActiveAccount(tradeableAccount.login, tradeableAccount.source);
                    })
                    .catch(function (error) {
                        log('can not login to tradeable account', tradeableAccount, error);
                        return $q.reject(Const.loginStatus.failedActiveAccount);
                    })
            }

            if (user.registrationPhase != "2") {
                return;
            }

            //return with no active account
            return $q.reject(Const.loginStatus.noActiveAccount);
        };


        this.mt4ClearServices = function () {
            return Utils.runChain(mt4ClearChain);
        };

        this.mt4InitServices = function () {
            return Utils.runChain(mt4InitChain);
        };

        this.mt4Logout = function () {
            //check if we are loggedIn
            var user = UserService.get(),
                p = $q(function (resolve, reject) {
                    resolve();
                });

            function isLoggedIn() {
                return user.isLoggedInMT4 && API.mt4Logout();
            }

            return p
                .then(isLoggedIn)
        };

        this.login = function (login, password, otpCode) {
            var request = {login: login, password: password, fingerprint: fingerprint};

            if (Const['enable2FA'] && otpCode) {
                request.otpCode = otpCode
            }

            return API.loginDetailsMT4(request)
                .then(checkLogin)
                .then(saveToken)
                .then(initUser)
        };

        this.loginThirdParty = function (login, provider, tokenThirdParty) {
            var request = {
                login: login,
                password: "",
                fingerprint: fingerprint,
                provider: provider,
                tokenThirdParty: tokenThirdParty
            };

            return API.loginThirdParty(request)
                .then(checkLogin)
                .then(saveToken)
                .then(initUser)
        };

        this.loginWebTrader = function (login, password, source) {
            var request = {
                login: login,
                password: password,
                source: source,
                fingerprint: fingerprint
            }

            return API.loginWebTrader(request)
                .then(checkLogin)
                .then(saveToken)
                .then(initUser)
        }

        function checkTradeLogin(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'LoginService',
                    type: Const.error.type.VALIDATION,
                    code: 'tradeLoginFailed',
                    severity: 'warning',
                    data: {response: data}
                });
            }

            return data;
        }

        this.logout = function () {

            LocalStorage.remove('token');

            SocialAuthService.signOut()

            return self.clearServices()
                .then(API.logout)
                .then(function () {
                    LocalStorage.remove('activeAccount');
                    CustomerEventsService.stopSessionPing();
                });
        };

        this.initServices = function () {
            log('init services');
            return Utils.runChain(initChain);
        };

        this.clearServices = function () {
            log('clear services');

            // $rootScope.$broadcast('clear');
            return Utils.runChain(clearChain);
        };

        return this;

    }]);
